import React from 'react';
import { Modal } from 'react-bootstrap';
import { errors } from './errors';

export function DocumentsUploaderErrorModalIcon() {
  return (
    <img
      className="mb-6"
      src="/static/img/illustrations/desktop-error.svg"
      width={120}
      alt="Mujer sentada frente a un computador, con un error en la pantalla"
    />
  );
}

export function DocumentsUploaderErrorModalInformation(
  { reason, description }:
  { reason?: string, description?: string }) {
  const fallbackReason = errors.GENERIC.reason;
  const fallbackDescription = errors.GENERIC.description;
  return (
    <>
      <h1 className="fs-xl text-primary mb-4 text-center">
        {reason || fallbackReason}
      </h1>

      <p className="text-subtitle fs-lg mb-6 text-center">
        {description || fallbackDescription}
      </p>
    </>
  );
}

export function DocumentsUploaderErrorModalActions({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="row justify-content-center w-100">
      <div className="col-md-6">
        <button type="button" className="btn btn-primary w-100" onClick={onRetry}>
          Reintentar
        </button>
      </div>
    </div>
  );
}

interface DocumentsUploaderErrorModalProps {
  show: boolean;
  onHide: () => void;
  reason?: string;
  description?: string;
}

export function DocumentsUploaderErrorModal(
  {
    show, onHide, reason, description,
  } :DocumentsUploaderErrorModalProps) {
  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Body className="d-flex flex-column align-items-center p-6">
        <DocumentsUploaderErrorModalIcon />
        <DocumentsUploaderErrorModalInformation
          reason={reason}
          description={description}
        />

        <DocumentsUploaderErrorModalActions onRetry={onHide} />
      </Modal.Body>
    </Modal>
  );
}
